/**
 * propertyStatusAtOrigination
 */
export const selectOptionsPropertyStatusAtOrigination = [
  "Raw land without approved plans and/or utilities",
  "Raw land with approved plans and utilities in place",
  "Foundation in place",
  "Significant Progress to Exterior, limited or no exterior work complete",
  "Finishing Interior",
  "Requires significant renovation",
  "Average condition - requires moderate renovation",
  "Above Average condition - requires limited renovation",
  "Vacant",
  "Occupied",
  "Recently Rennovated - On Market",
  "Recently Rennovated - Leased",
  "Recently Rennovated - Pending Lease",
];
